import { render, staticRenderFns } from "./EmptyRouterView.vue?vue&type=template&id=6325a460&scoped=true&"
import script from "./EmptyRouterView.vue?vue&type=script&lang=js&"
export * from "./EmptyRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6325a460",
  null
  
)

export default component.exports